import { RootState } from '../store';

export const getSessionId = (state: RootState) => state.session.sessionId;
export const getTargetUrl = (state: RootState) => state.session.targetUrl;
export const getNetworkRequests = (state: RootState) => state.session.networkRequests;
export const getQrValue = (state: RootState) => state.session.qrValue;
